import { render, staticRenderFns } from "./DeleteQuestionImage.vue?vue&type=template&id=9e36f94c"
import script from "./DeleteQuestionImage.vue?vue&type=script&lang=js"
export * from "./DeleteQuestionImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports